import { render, staticRenderFns } from "./diagnosis.vue?vue&type=template&id=679aec4e&scoped=true"
import script from "./diagnosis.vue?vue&type=script&lang=js"
export * from "./diagnosis.vue?vue&type=script&lang=js"
import style0 from "./diagnosis.vue?vue&type=style&index=0&id=679aec4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679aec4e",
  null
  
)

export default component.exports